import { useMemo } from 'react'
import { Chart, type AxisOptions } from 'react-charts'
import { format, parse } from 'date-fns'
import { useListingViews } from './useListingViews'
import { useListingImpressions } from './useListingImpressions'

export const InsightsChart = ({
  listingId,
  period
}: {
  listingId: string
  period: '7d' | '30d' | '30dp'
}) => {
  const { data: views } = useListingViews({ listingId, period: period })
  const { data: impressions } = useListingImpressions({ listingId, period: period })

  const primaryAxis = useMemo(
    (): AxisOptions<(typeof views)[number]> => ({
      getValue: datum => datum.date,
      formatters: {
        scale: (value: string | null) => {
          return value ? format(parse(value, 'yyyy-MM-dd', new Date()), 'MMM d') : ''
        }
      }
    }),
    []
  )

  const secondaryAxes = useMemo(
    (): AxisOptions<(typeof views)[number]>[] => [
      {
        getValue: datum => datum.count,
        elementType: 'line'
      }
    ],
    []
  )

  return (
    <Chart
      options={{
        data: [
          { label: 'Views', data: views },
          { label: 'Impressions', data: impressions }
        ],
        primaryAxis,
        secondaryAxes
      }}
    />
  )
}
